import DynamicForm from "components/DynamicForm";
import React, { Fragment, useEffect, useState ,useCallback} from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import option from "../../assets/images/option.svg";
import guardianLogo from "../../assets/images/Guardian_Logo.svg";
import { Image } from "lib";
import "./index.scss";
import { setPopupData, clearPopupData } from "redux/popupReducer";
import { useSelector, useDispatch } from "react-redux";
import { ActionButtons } from "lib/ActionButtons";
import {
  linkCrnToWorkflow,
  reInitiateVkyc,
  sendreminderAboutStatus,
  updateDataAndStatusById,
} from "api/dashboardDetail";
import { useNavigate } from "react-router-dom";
import { clearToastContainer, setCheckingForApprovalButtonConstraint } from "redux/dashBoardDetailReducer";
import { fetchUsersWithRole } from "api/user";
import { clearSelectedDataKey } from "redux/formDisplay";
import { createLinkExpiry } from "api/configuration";
import { cleardeleteDocument } from "redux/uploadDocumentReducer";
import { generateCommunicationAddress, getDependentNamesByGuardianId } from "helper";
import Toast from "components/ToastComponent"
// import { config } from "assets/common/dynamicConfig";
import {
  setShowDataPreview,
  setShowRecursiveForm,
  setShowAddMore,
  setRecursiveActions,
  setAddSaveData,
  clearRecursiveFormDataKey,
  cleardeleteRecursiveDocument,
  setShowData,
  setFormFields,
} from "redux/recursiveReducer";
import { setdeleteDocument } from "redux/uploadDocumentReducer"
import Dropdown from 'react-bootstrap/Dropdown';
import { calculateGrade } from "helper/calculateNetAsset";
import PropTypes from "prop-types";
import LoadingSpinner from "lib/LoadingSpinner";
import { OverlayTrigger, Popover } from "react-bootstrap";


function CommonTabs(props) {
  const { formFields, selectedData } = props;
  const [showPopModal, setShowPopModal] = useState(false);
  const [popupState, setPopupState] = useState({});
  const user_role = sessionStorage.getItem("currentUserRole") || null;
  const loggedInUserInfo = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo
  );
  const userId = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo?.profileInfo?.userId
  )
  const params = useSelector((state) => state?.urlEncryption?.urlParams);
  const recursiveFormData = useSelector(
    (state) => state.recursive?.recursiveFormData
  );
  const recursive = useSelector((state) => state?.recursive);
  const deleteRecursiveDocument = useSelector((state) => state.recursive?.deleteRecursiveDocument);
  const vkycCallback = useSelector(
    (state) => state?.dashboardDetailReducer?.userSubworkFlowInfo?.vcip_callback
  );
  const IndirectEval = (evalString) => {
    return eval(evalString);
  }

  const activeTab = useSelector((state)=>state?.dashboardDetailReducer?.activeNavTab)
  let actionDropdownRendered = false;

  const current_user = loggedInUserInfo?.profileInfo?.role_name
  const dispatch = useDispatch();
  const { popupData } = useSelector((state) => state.popupReducer);
  const uploadedDocument = useSelector(
    (state) => state.uploadDocumentReducer?.uploadedDocument
  );
  const organisationInfo = useSelector((state) => state?.loggedInUserInfo?.userAuthInfo?.organisationInfo)
  const approvalHistory = useSelector((state)=> state?.dashboardDetailReducer?.workFlowInfo?.step_history)
  const roleId = useSelector((state) => state.popupReducer?.role_id)
  const isConditional = useSelector((state) => state.popupReducer?.is_conditional)
  const wfJourney = useSelector(
    (state) => state?.configurationReducer?.config?.wf_journey
  );
  const selectedQuestion = useSelector(
    (state) => state.formData?.selectedQuestion
  );
  const questionData = useSelector((state) => state.formData?.questionData);
  const deleteDocument = useSelector((state) => state?.uploadDocumentReducer?.deleteDocument)
  const org_id = selectedData?.subworkFlowInfo?.organisation_id || loggedInUserInfo?.profileInfo?.organisationId
    const actionSuccess = useSelector((state) => state?.dashboardDetailReducer?.actionSuccess)
  const flattendData = {
    ...uploadedDocument,
    ...selectedData.primaryworkflow,
    ...selectedData.subworkFlowInfo,
    subworkFlowInfo: selectedData.subworkFlowInfo,
    ...selectedData,
    ...popupData,
  };
  //getting the configuration module id
  const moduleId = useSelector((state) => state?.dashboardDetailReducer?.dashboardDetailConfiguration?.configurationInfo?.module_id);
  const asigned_step = useSelector((state) => state.popupReducer?.activeStep)
  const all_users = useSelector((state)=> state.dashboardReducer?.allUsers)

  const subworkflowInfo = useSelector(
    (state) => state?.dashboardDetailReducer?.userSubworkFlowInfo
  )?.source_data;

  const [formErr, setFormErr] = useState({});
  const [actionBtnCongif, setActionBtnCongif] = useState({});
  const [triggerTo, setTriggerTo] = useState("");
  const navigate = useNavigate();
  const [toast, setToast] = useState(false);
  const [loading, setLoading] = useState(false);
  const shouldShowActionButtonsForApproval = useSelector((state) => state?.dashboardDetailReducer?.shouldShowActionButtonsForApproval);
  const [sendReminderToast, setSendReminderToast] = useState({
    status: false,
    type: "",
    message: ""
  });

  const shouldAllowApproveReject = () => {
    const primaryWorkflow = selectedData?.primaryworkflow;
    const userStepRoleMapping = primaryWorkflow?.user_step_role_mapping || [];

    if (userStepRoleMapping.length === 0) {
      return false; // No user step role mapping found
    }

    const { role, userId } = loggedInUserInfo?.profileInfo || {};
    const activeStep = primaryWorkflow.active_step;

    const findStepMatch = userStepRoleMapping.find(
      (matchActiveStep) =>
        matchActiveStep?.step === activeStep &&
        matchActiveStep?.role?.toString() === role?.toString() &&
        matchActiveStep?.user_id?.toString() === userId?.toString()
    );

    return !!findStepMatch;
  };

  const checkRenderAllowed = useCallback(
     (
      currentStep,
      loggedInUserInfo,
      dispatch,
      IndirectEval
    ) => {
      try {
        const { module_settings } = currentStep;
        if (!module_settings) return false;
        const { approved_by } = module_settings;

        if (!approved_by) return false;

        if (approved_by.type && approved_by.group_id?.length) {          
          return shouldShowActionButtonsForApproval;
        }

        const allowed_role = approved_by.role_id;
        const allowed_user = approved_by.user_id;
        const current_role = loggedInUserInfo?.profileInfo?.role;
        let showApprovedBy = false;
        if (current_role && allowed_role.includes(current_role)) {
          showApprovedBy = approved_by.show ? IndirectEval(approved_by.show) : true;
        }else{
          allowed_user.map((item)=>{
            if(userId == item){           
              showApprovedBy = true;
            }
          })
          if(subworkflowInfo?.assign_approval_user_id == userId){
            showApprovedBy = true;
          }

        }
        return showApprovedBy;
      } catch (error) {
        console.error("Error in checkRenderAllowed:", error);
        return false;
      } finally {
        dispatch(setCheckingForApprovalButtonConstraint(false));
      }
    },
    [selectedData?.subworkFlowInfo?.active_step,shouldShowActionButtonsForApproval])
  
  
  const handleSetActionBtnConfig =  (selectedData, currentStep) => {
    try {
      
      // const config =
      //   formFields?.action_buttons?.find((e) => e?.show && eval(e.show)) || {};
      const config = checkRenderAllowed(
        currentStep,
        loggedInUserInfo,
        dispatch,
        IndirectEval
      )
        ? currentStep?.module_settings
        : {};
      if (!wfJourney) {
        setActionBtnCongif({});
        return;
      }
      if (config?.is_parallel_approval) {
        const module = wfJourney?.find(
          (wf) => wf?.step === selectedData?.primaryworkflow?.active_step
        );
        const is_parallel =
          module?.step >= selectedData?.subworkFlowInfo?.active_step || false;
        setActionBtnCongif(is_parallel ? config : {});
      } else {
        setActionBtnCongif(config);
      }
    } catch (error) {
      console.error("Error in handleSetActionBtnConfig:", error);
    }
  };

  useEffect(() => {
    if (wfJourney) {
      let current_step = wfJourney?.filter(
        (e) => e?.step == selectedData?.subworkFlowInfo?.active_step
      );
      current_step = current_step?.length ? current_step[0] : {};
      if (current_step) {
        handleSetActionBtnConfig(selectedData, current_step);
      }
    }
  }, [selectedData?.subworkFlowInfo?.active_step, wfJourney, actionSuccess,shouldShowActionButtonsForApproval]);

  const handleClick = async (action) => {
    if (action === "send_reminder") {
      let userName;
      let redirectURL = "";
      if (
        organisationInfo?.setting?.link_expiry_duration_in_hours
      ) {
        const linkExpiryObjectID = await dispatch(
          createLinkExpiry({
            organisation_id: selectedData?.primaryworkflow?.organisation_id,
            type: "Invite Customer",
            hours: organisationInfo?.setting?.link_expiry_duration_in_hours,
          })
        ).unwrap();

        if (linkExpiryObjectID) {
          if (selectedData?.subworkFlowInfo?.link.includes("token=")) {
            redirectURL = selectedData?.subworkFlowInfo?.link.replace(
              /token=[^&]+/,
              linkExpiryObjectID?.data
            );
          } else {
            const separator = selectedData?.subworkFlowInfo?.link.includes("?")
              ? "&"
              : "?";
            redirectURL = `${selectedData?.subworkFlowInfo?.link}${separator}${linkExpiryObjectID?.data}`;
          }
        }
      }
      if (selectedData?.subworkFlowInfo?.last_name) {
        userName =
          selectedData?.subworkFlowInfo?.first_name +
          " " +
          selectedData?.subworkFlowInfo?.last_name;
      } else userName = selectedData?.subworkFlowInfo?.first_name;
     let subworkFlowData = selectedData?.subworkflows?.find(item => 
      (item?._id ==selectedData?.subworkFlowInfo?._id )
    )
      const body = {
        is_primary: false,
        subWfId: selectedData?.subworkFlowInfo?._id,
        userName: userName,
        email_id: selectedData?.subworkFlowInfo?.email,
        org_id: selectedData?.primaryworkflow?.organisation_id,
        status: selectedData?.subworkFlowInfo?.status,
        trigger: action ? action : "send_reminder",
        link: redirectURL || subworkFlowData?.link,
      };
      // dispatch(sendreminderAboutStatus(body));
      let resp = await dispatch(sendreminderAboutStatus(body)).unwrap();
      if (resp?.status == "success") {
        setSendReminderToast({
          status: true,
          type: "success",
          message: resp?.message
        })
      } else if(resp?.status == "failed"){
        setSendReminderToast({
          status: true,
          type: "error",
          message: resp?.message
        })
      }
      setTimeout(() => {
        setSendReminderToast({
          status: false,
          type: "",
          message: "Unable to send reminder"
        })
      }, 3000);


    }
    if (typeof action === "string" && action.includes("custom_popups::")) {
      const action_of = action.replace("custom_popups::", "");
      if (formFields?.custom_popups?.[action_of]) {
        const customPopupConfig = formFields?.custom_popups[action_of];
        const approveObj = {
          _of: action,
          config: customPopupConfig,
        };
        setPopupState(approveObj);
        approveObj?.config?.form_elements && setShowPopModal(true);
      }
    } else if (action === "reject") {
      const rejectObj = {
        _of: "reject",
        config: actionBtnCongif?.reject_flow,
      };
      setPopupState(rejectObj);
      rejectObj?.config?.form_elements && setShowPopModal(true);
    } else if (action === "approve") {
      const approveObj = {
        _of: "approve",
        config: actionBtnCongif?.approval_flow,
      };
      if (selectedData?.subworkFlowInfo?.status == "Rejected") {
        dispatch(clearSelectedDataKey({ key: "assign_rejection_to" }))
      }
      setPopupState(approveObj);
      approveObj?.config?.form_elements && setShowPopModal(true);
    } else if (action === "OnHold") {
      const onholdObj = {
        _of: "OnHold",
        config: actionBtnCongif?.onhold_flow,
      };
      setPopupState(onholdObj);
      onholdObj?.config?.form_elements && setShowPopModal(true);
    } else if (action === "reinitiate") {
      let reinitiateObj = {
        _of: "reinitiate",
        config: actionBtnCongif?.reinitiate_flow
      }
      setPopupState(reinitiateObj);
      reinitiateObj?.config?.form_elements && setShowPopModal(true);
    }
  };

  let email_params;
  useEffect(() => {
    email_params = popupState?.config?.email_params
    email_params?.forEach((item) => {
      if(item?.notification){
        setTriggerTo(item.notification)
      }else if (item?.is_conditional && item?.is_user) {
        setTriggerTo("customer")
      }
      else if (!item?.is_conditional && !item?.is_internal && item?.is_role) {
        setTriggerTo("user")
      }
      else if (item?.is_internal) {
        setTriggerTo("internal_poc")
      }
    })
  }, [popupState])
  // console.log(popupState);

  const popBtnClick = async (action, extra_params) => {
    if (action && action == 'add') {
      let fields = popupState?.config?.form_elements

      let formattedFormFields = fields[0].input_fields.filter(
        (item) => item.type != "toggle"
      );
      dispatch(setFormFields(formattedFormFields));
      dispatch(setRecursiveActions(fields[0]?.recursive_actions));

      let setShowRecursiveData = {},
        saveRecursiveData = {};
      formattedFormFields.map((item, index) => {
        if (recursiveFormData[item.name] && IndirectEval(item?.show)) {
          saveRecursiveData[item.name] = recursiveFormData[item.name];
          setShowRecursiveData[item.name] = recursiveFormData[item.name];
        }
        if (recursiveFormData?.hasOwnProperty('verification_response')) {
          saveRecursiveData['verification_response'] = recursiveFormData['verification_response'];
          dispatch(clearRecursiveFormDataKey({ key: 'verification_response' }))
        }
      });
      if (recursive?.isSignerRecursion == true && recursive?.signerParams?.hasOwnProperty('signature_position') && recursive?.signerParams?.hasOwnProperty('trigger_esign_request')) {
        saveRecursiveData['signature_position'] = recursive?.signerParams['signature_position'];
        saveRecursiveData['trigger_esign_request'] = IndirectEval(recursive?.signerParams['trigger_esign_request']);
      }
      if (recursive?.isSignerRecursion == true) {
        saveRecursiveData['co_signer'] = true
      }
      if (deleteRecursiveDocument) {
        deleteRecursiveDocument?.map((ele) => {
          dispatch(setdeleteDocument({ key: '', value: ele }))
        })
        dispatch(cleardeleteRecursiveDocument())
      }
      let recursiveNameFields = [];
      fields[0].input_fields.map((item) => {
        if (item.type == "toggle") return;
        return recursiveNameFields.push({ name: item.name, label: item.label });
      });

      recursiveNameFields.map((item) => {
        dispatch(clearRecursiveFormDataKey({ key: item.name }));
      });

      dispatch(setShowData(setShowRecursiveData));
      dispatch(setAddSaveData(saveRecursiveData));
      dispatch(setShowRecursiveForm(false));
      dispatch(setShowAddMore(true));
      dispatch(setShowDataPreview(true));

    } else {
      setShowPopModal(false);
      const selectedData = { ...flattendData };
      let request_body = { ...extra_params };
      if (action) {
        if (popupState?.config?.form_elements) {
          for (const element of popupState?.config?.form_elements) {
            if(element.type === 'quizModule' && selectedQuestion && questionData) {

          // Combinining questionData array and selectedQuestion object into a single object
            const combinedObject = {};

            questionData.forEach((item) => {
                const questionId = item["question_id"];
                const selectedValue = selectedQuestion[questionId];
                combinedObject[questionId] = {
                  ...item,
                  score: selectedValue
                };
              });
     
              let approvalQuizArray =  Object.values(combinedObject);
              let quizscore = approvalQuizArray.reduce((acc, curr) => acc + parseInt(curr.score), 0)
              let quizgrade = calculateGrade(quizscore, element.rules)
              request_body['approvalQuiz'] = approvalQuizArray;
              request_body['quizscore'] =  quizscore;
              request_body['quizgrade'] = quizgrade.grade
            }
            if (
              element.type === "upload" &&
              uploadedDocument?.[element?.name] &&
              !!(element?.show ? eval(element?.show) : true)
            ) {
              request_body.uploadedDocument = {
                ...request_body?.uploadedDocument,
                [element.name]: uploadedDocument?.[element?.name],
              };
            }
            if (
              element?.type !== "upload" &&
              flattendData?.[element?.name] &&
              !!(element?.show ? eval(element?.show) : true)
            ) {
              if (element?.store_in_primary_workflow) {
                request_body.primary_workflow_keys = {
                  ...request_body.primary_workflow_keys,
                  [`source_data.${element.name}`]: flattendData?.[element?.name],
                };
              } else if (element?.name?.includes("remarks") || element?.name?.includes("remark")) {
                request_body[`source_data.${element.name}`] =
                  flattendData?.[element?.name];
                request_body["approve_rejection_keyname"] = element?.name
                request_body["remark"] = flattendData?.[element?.name];
              } else {
                request_body[`source_data.${element.name}`] =
                  flattendData?.[element?.name];
              }
            }
            if (element.type === "multipleFileUpload") {
              for (let property in flattendData) {
                if (
                  flattendData.hasOwnProperty(property) &&
                  property.toString().startsWith(element?.name)
                ) {
                  if (flattendData?.[property]?.field_label) {
                    request_body.uploadedDocument = {
                      ...request_body?.uploadedDocument,
                      [property]: flattendData[property],
                    };
                  }
                }
              }
            }
          }
        }
      }
      if (popupState?.config?.generateCommunicationAddress) {
        generateCommunicationAddress(request_body, selectedData)
      }
      const data = {
        // [`${current_user}_${popupState?._of}_data`]: request_body,
        ...request_body,
        userId: selectedData?.subworkFlowInfo?._id,
        workFlowId : selectedData?.subworkFlowInfo?._id,
        isApprove: popupState?._of === "approve" ? true : false,
        current_role: current_user,
        loggedInUserId: loggedInUserInfo?.profileInfo?.userId,
        email_params: triggerTo,
        org_id: org_id,
        current_status:selectedData?.status,
        current_active_step:selectedData?.active_step,
        deleteDocument: deleteDocument,
        //fetching the detailview module id
        detail_view_module_id:moduleId
      };
      if (deleteDocument?.length) {
        dispatch(cleardeleteDocument())
      }
      let module;
      let active_step = selectedData?.subworkFlowInfo?.active_step;
      module = wfJourney?.find(
        (wf) => wf?.step == active_step && wf?.active && eval(wf?.active)
      );
      if (selectedData?.subworkFlowInfo?.status === "Rejected") {
        if (popupState?._of === "reject") {
          let roleInfo = {
            organisation_id: loggedInUserInfo?.organisationInfo?._id,
            role: roleId
          }
          let response;
          if (triggerTo === "user") {
            response = await fetchUsersWithRole(roleInfo)
          }
          if (triggerTo?.includes("prev_all") || triggerTo?.includes("prev")) {
            data["approver_notification_data"] = triggerTo.includes("prev_all") ? approvalHistory : [approvalHistory[approvalHistory?.length - 1]];
          }
          data["role_details"] = response
          data["is_conditional"] = isConditional
          data.status = "Rejected";
          delete data["source_data.assign_rejection_to"];
            const roleAndStep = popupData?.assign_rejection_to?.split("::") || [
              "Terminated",
              2,
            ];
            if (roleAndStep[0] === "Terminated") {
              data.status = "Terminated";
            }
            const activeStep = popupData?.dynamic_step  ? (parseInt(popupData?.dynamic_step) || parseInt(popupData?.rejected_dynamic_step) || parseInt(asigned_step))  : roleAndStep[1] || module?.previous_step;
            data.active_step = parseInt(activeStep);
            data.max_active_step = eval(module?.previous_step) ? eval(module.previous_step) : "";
            console.log("🚀 ~ popBtnClick ~ module:", module)
            data.rejection_type = module?.rejection_type ? module?.rejection_type : 'parallel';
            data.rejection_flow_in_progress = data.max_active_step > data.active_step ? true : false;
            data.assign_rejection_to = roleAndStep[0];
            if (data.max_active_step === 1) {
              data.is_terminate = true;
              data.max_active_step = 2;
            }
        } else if(popupState?._of === "approve") {
          data[
            `source_data.${current_user
              .replace(" ", "_")
              .toLowerCase()}_approve_remarks`
          ] = data["source_data.approve_remarks"];
          delete data["source_data.approve_remarks"];
          let rejection_type = selectedData?.subworkFlowInfo?.rejection_type || "parallel"
          if (rejection_type.toLowerCase() == 'sequential' && selectedData?.subworkFlowInfo?.rejection_flow_in_progress) {
            active_step = selectedData?.subworkFlowInfo?.active_step;
            module = wfJourney?.find(
              (wf) => wf?.step == active_step && wf?.active && eval(wf?.active)
            );
            // future there might be a possibility where evaluation from rejection might need to be skipped based on condition
            while (module.module_name !== 'approval') {
              active_step = active_step + 1;
              module = wfJourney?.find(
                (wf) => wf?.step == active_step && wf?.active && eval(wf?.active)
              );
              // console.log("module data 2-->", module?.module_name)
  
            }
          } else if (selectedData?.subworkFlowInfo?.rejection_flow_in_progress) {
            active_step =
              selectedData?.subworkFlowInfo?.max_active_step || active_step;
            module = wfJourney?.find(
              (wf) => wf?.step == active_step && wf?.active && eval(wf?.active)
            );
  
          }
          data.assign_rejection_to = "";
        }
      }
      if (popupState?._of === "approve") {
        if (selectedData?.subworkFlowInfo?.is_terminate) {
            data.is_terminate = false;
        }
    
        const next_id = popupState?.config?.next_role;
        const next_show_condition = popupState?.config?.role_show;
        let showCond;
        if (next_show_condition) {
            showCond = eval(next_show_condition);
        }
        data["next_role"] = showCond ? showCond : next_id;
    
        if (triggerTo?.includes("prev_all") || triggerTo?.includes("prev")) {
            data["approver_notification_data"] = triggerTo.includes("prev_all")
                ? approvalHistory
                : [approvalHistory[approvalHistory?.length - 1]];
        }
        data.approval_flow_in_progress =  false;
      
        if (popupData?.assign_approval_to) {
            data.active_step =  parseInt(popupData?.dynamic_step) || parseInt(popupData?.rejected_dynamic_step) ||  parseInt(asigned_step)  ;
            const current_status = wfJourney?.find((wf) => wf?.step == data.active_step)?.current_activity;
            data.status = current_status;
            data.max_active_step = eval(module?.previous_step)
                ? eval(module.previous_step)
                : "";
            data.approval_type = module?.approval_type
                ? module?.approval_type
                : "parallel";
            // data.approval_flow_in_progress =  data.max_active_step > data.active_step ? true : false; 
            data.approval_flow_in_progress =  true;
   
                data.assign_approval_user_id =  popupData?.assign_approval_to;  
                data.dynamic_step = popupData?.dynamic_step         
            // data.assign_approval_to = popupData?.assign_approval_to;
        } else {
            if (selectedData?.subworkFlowInfo?.rejection_flow_in_progress && selectedData?.subworkFlowInfo?.rejection_type === "sequential") {
                let nextStep = module?.is_conditional
                    ? eval(module?.next_step)
                    : module?.next_step;
                let nextModule = wfJourney?.find(
                    (wf) => wf?.step === nextStep && wf?.active && eval(wf?.active)
                );
                while (nextModule.module_name !== "approval") {
                    active_step = active_step + 1;
                    module = nextModule;
                    nextModule = wfJourney?.find(
                        (wf) =>
                            wf?.step === active_step && wf?.active && eval(wf?.active)
                    );
                }
                if (nextModule?.step > selectedData?.subworkFlowInfo?.max_active_step) {
                    data.rejection_flow_in_progress = false;
                }
            }
            data.status = module?.is_conditional
                ? eval(module?.next_activity)
                : module?.next_activity;
            data.previous_active_step = selectedData?.subworkFlowInfo?.active_step;
            data.active_step = module?.is_conditional
                ? eval(module?.next_step)
                : module?.next_step;
            if (
                selectedData?.subworkFlowInfo?.rejection_flow_in_progress &&
                selectedData?.subworkFlowInfo?.rejection_type !== "sequential"
            ) {
                data.rejection_flow_in_progress = false;
            }
    
            // Condition for generating CRN
            if (
                module.hasOwnProperty("application_sequence") &&
                IndirectEval(module.application_sequence?.required)
            ) {
                data.application_sequence = module.application_sequence;
            }
        }
    }
    else if (popupState?._of === "reinitiate") {
        let reinitiateParams = {
          primary_wf_id: params?.primaryWorkflowId,
          user_id: loggedInUserInfo?.profileInfo?.userId,
          sub_wf_id: selectedData?.subworkFlowInfo?._id,
          organisation_id: organisationInfo?._id
        }
        setToast(true);
        setLoading(true);
        let response = await dispatch(reInitiateVkyc(reinitiateParams));
        if (response?.meta?.requestStatus === "fulfilled") {
          window.location.reload();
          setLoading(false);
        }
        setTimeout(() => {
          setToast(false);
        }, 3000);
        return
      } else if (popupState?._of === "reject") {
        let roleInfo = {
          organisation_id: loggedInUserInfo?.organisationInfo?._id,
          role: roleId
        }
        let response;
        if (triggerTo === "user") {
          response = await fetchUsersWithRole(roleInfo)
        }
        if (triggerTo?.includes("prev_all") || triggerTo?.includes("prev")) {
          data["approver_notification_data"] = triggerTo.includes("prev_all") ? approvalHistory : [approvalHistory[approvalHistory?.length - 1]];
        }
        data["role_details"] = response
        data["is_conditional"] = isConditional
        data.status = "Rejected";
        delete data["source_data.assign_rejection_to"];
        if (selectedData?.subworkFlowInfo?.status !== "Rejected") {
          const roleAndStep = popupData?.assign_rejection_to?.split("::") || [
            "Terminated",
            2,
          ];
          if (roleAndStep[0] === "Terminated") {
            data.status = "Terminated";
          }
          const activeStep = popupData?.rejected_dynamic_step ? ( parseInt(popupData?.rejected_dynamic_step) || parseInt(asigned_step) ) :  roleAndStep[1] || module?.previous_step;
          data.active_step = parseInt(activeStep);
          data.max_active_step = eval(module?.previous_step) ? eval(module.previous_step) : "";
          console.log("🚀 ~ popBtnClick ~ module:", module)
          data.rejection_type = module?.rejection_type ? module?.rejection_type : 'parallel';
          data.rejection_flow_in_progress = data.max_active_step > data.active_step ? true : false;
          data.assign_rejection_to = roleAndStep[0];
          if (data.max_active_step === 1) {
            data.is_terminate = true;
            data.max_active_step = 2;
          }
        }
      } else if(popupState?._of === "OnHold") {
        data.status = "OnHold";
        flattendData.status = "OnHold";
      }

      if(selectedData?.isGroupApproval){
        data["is_group_approval"] = true;
      }

      // console.log("data rece", data)
      dispatch(updateDataAndStatusById(data))
        .unwrap()
        .then(() => {
          if (data.status === "Rejected") {
            setTimeout(() => {
              dispatch(clearToastContainer());
              navigate("/dashboard-listing");
            }, 2600);
          }
        });
    }
  };

  const clearFieldError = (fields, isList) => {
    fields = isList ? fields : [fields];
    let err = { ...formErr };

    for (let key in fields) {
      const _field = fields[key];
      if (err[_field] !== undefined) {
        delete err[_field];
      }
    }

    setFormErr(err);
  };

  const handleDelinkWithCrn = () => {
    const { subworkFlowInfo, config } = selectedData || {};
    const { form_elements } = popupState?.config || {};
    const request_body = {
      action: "delink",
      primary_workflow_id: subworkFlowInfo?.primary_workflow_id || "",
      user_id: subworkFlowInfo?.user_id || "",
      crn: subworkFlowInfo?.crn,
    };
  
    if (form_elements) {
      for (const element of form_elements) {
        const { type, name } = element;
        const value = flattendData?.[name];
  
        if (type === "upload" && value) {
          request_body.uploadedDocument = {
            ...request_body.uploadedDocument,
            [name]: value,
          };
        } 
        else 
        if (type !== "upload" && value) {
          request_body[name] = value;
        }
      }
    }
  
    dispatch(linkCrnToWorkflow(request_body));
    setShowPopModal(false);
  };
  

  const handelAddRecursiveData = () => {
    let request_body = {}
    let previous_data = []
    if (recursive?.isSignerRecursion == true && selectedData?.subworkFlowInfo['signers_info']) {
      let signers_details = selectedData?.subworkFlowInfo?.signers_info[0]
      let signers_info = [signers_details]
      let allSignerData = recursive?.signerParams?.signer_validation_name
      if (allSignerData?.length > 0) {
        allSignerData.forEach((item) => {
          if (selectedData?.subworkFlowInfo[item]) {
            let sign_data = selectedData?.subworkFlowInfo[item]
            signers_info = [...signers_info, ...sign_data]
          }
        })
      }
      signers_info = [...signers_info, ...recursive?.saveData]
      request_body['source_data.signers_info'] = signers_info
    }
    let newdata = [...recursive?.saveData]
    if (recursive?.saveData?.length == 0) {
      newdata = false
    }
    request_body[`source_data.${recursive.arrayName}`] = newdata

    const data = {
      ...request_body,
      workFlowId: selectedData?.subworkFlowInfo?._id,
      isApprove: popupState?._of === "approve" ? true : false,
      current_role: current_user,
      loggedInUserId: loggedInUserInfo?.profileInfo?.userId,
      email_params: triggerTo,
      org_id: org_id,
      deleteDocument: deleteDocument,
      loggedInUserInfo : loggedInUserInfo
    }
    dispatch(updateDataAndStatusById(data))

  }


  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader " />
      </div>
    );
  }

  return (
    <>
     {sendReminderToast?.status && (
              <Toast
                  type={sendReminderToast?.type}
                  message={sendReminderToast?.message}
                  autoClose={3000}
              />
          )}
      {toast && (
        <Toast
          message="Reinitiation link sent for Video KYC"
          type="success"
          autoClose={3000}
        />
      )}
      <div className="common_tab_header">
        <Tabs
          id="controlled-tab-example"
          activeKey={selectedData?.commonTabKey}
          onSelect={selectedData?.setCommonTabKey}
          className={`mt-2  detail-nav-tabs border-2 border-transparent ${selectedData?.subworkflows?.length > 2 ? 'overflow-x-scroll theme-scrollbar pb-2' : 'pb-3'}`}
        >
          {selectedData?.[formFields?.form_field]?.map((_item, index) => (
            <Tab             
              eventKey={_item?._id}
              title={<div style={{display:"flex",flexDirection:"row"}}>{_item?.[formFields?.form_key]} {_item?.delinked ? " (Delinked)" : _item?.linked ? " (Linked)" : ""} {_item?.guardian_of ? <OverlayTrigger
                placement="top"
                delay={{ show: 50, hide: 400 }}
                overlay={<Popover  id="tooltip-for-guradians"  style={{
                  backgroundColor: "#4D4D4D",
                  textAlign: "center",
                  paddingLeft: "5px",
                  paddingRight: "5px",
                }}>
                  <div style={{ textAlign: "center", color: "white", marginTop: "10px", fontWeight: "light",fontSize:"small" }}>
                    {"Guardian of "+getDependentNamesByGuardianId(selectedData?.[formFields?.form_field],_item.uid)}
                  </div>
                </Popover>}>
                <div style={{marginLeft:"5px"}}><Image imageSrc={guardianLogo} /></div>
              </OverlayTrigger> : null}</div>}
              key={index}
            >
              {formFields &&
                formFields?.form_elements?.map((item, i) => {
                  if (item?.type) {
                    return (
                      <div className="mb-3">
                        <Fragment key={i}>
                          <DynamicForm
                            formFields={item}
                            selectedData={selectedData}
                            tabIndex={index}
                          />
                        </Fragment>
                      </div>
                    );
                  } else return <Fragment key={i}></Fragment>;
                })}
            </Tab>
          ))}
        </Tabs>
        <div className="common_tab_header_buttons mt-0">

          { actionBtnCongif && (
            <>

              <div className="d-none d-lg-block">
                <ActionButtons
                  selectedData={flattendData}
                  setSelectedData={setPopupData}
                  popupConfig={popupState?.config || {}}
                  form_buttons={actionBtnCongif?.form_buttons || []}
                  showPopModal={showPopModal}
                  setShowPopModal={setShowPopModal}
                  popBtnClick={popBtnClick}
                  handleNext={handleClick}
                  handleDelinkWithCrn={handleDelinkWithCrn}
                  formErr={formErr}
                  clearFieldError={clearFieldError}
                  handelAddRecursiveData={handelAddRecursiveData}
                />
              </div>



{
  actionBtnCongif?.form_buttons?.map((item) => {
    if (!actionDropdownRendered && IndirectEval(item?.show)) {
      actionDropdownRendered = true; 
      return (
        <Dropdown className="d-lg-none mt-1">
          <Dropdown.Toggle className="fw-bold text-white fs-16px bg-primary-dark border-theme" id="dropdown-basic">
            Actions
            <span className="ms-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
              </svg>
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu className="px-2 z-index-0">
            <ActionButtons
              selectedData={flattendData}
              setSelectedData={setPopupData}
              popupConfig={popupState?.config || {}}
              form_buttons={actionBtnCongif?.form_buttons || []}
              showPopModal={showPopModal}
              setShowPopModal={setShowPopModal}
              popBtnClick={popBtnClick}
              handleNext={handleClick}
              handleDelinkWithCrn={handleDelinkWithCrn}
              formErr={formErr}
              clearFieldError={clearFieldError}
              handelAddRecursiveData={handelAddRecursiveData}
              customClass="m-0 p-0"
            />
          </Dropdown.Menu>
        </Dropdown>
      );
    }
  })
}
            </>
          )}

          {formFields?.options && eval(formFields?.options?.show) && (
            <DynamicForm
              formFields={formFields?.options}
              selectedData={selectedData}
              triggerItem={
                <a className="cursor-pointer popover-btn m-1">
                  <Image className="option_button" imageSrc={option} />
                </a>
              }
              handleItemClick={handleClick}
            />
          )}
        </div>
      </div>
    </>
  );
}

CommonTabs.propTypes = {
  formFields: PropTypes.object,
  selectedData: PropTypes.object,
};

export default CommonTabs;
